import { render, staticRenderFns } from "./ViGrandLogin.vue?vue&type=template&id=58be1a42"
import script from "./ViGrandLogin.vue?vue&type=script&lang=js"
export * from "./ViGrandLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports